import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Heading,
  Wrapper,
  Details,
  ButtonWrapper,
  Content,
} from "pages/Student/Payment/styles";
import Button from "components/atoms/Button";

const BookSessionFailure = () => {
  const history = useHistory();
  const location = useLocation<{ type: string }>();

  const query = new URLSearchParams(location.search);
  const reason = query.get("reason");

  const description = useMemo(() => {
    switch (reason) {
      case "used":
        return "Session is already used.";
      default:
        return "Unknown error occur. Please try again. If the error persist, please contact us";
    }
  }, [reason]);

  const moveToDashboard = () => history.push("/student");

  return (
    <Wrapper>
      <Content type="error">
        <Heading>Warning!</Heading>
        <Details>{description}</Details>
        <ButtonWrapper>
          <Button variant="primary" onClick={moveToDashboard}>
            OK
          </Button>
        </ButtonWrapper>
      </Content>
    </Wrapper>
  );
};

export default BookSessionFailure;
